<template>
  <ontos-creatable-autocomplete :label="hideLabel? undefined : property.name"
                  :items="items"
                  item-title="_identifier"
                  item-value="_instance"
                  :readonly="readonly"
                  :multiple="isMultiple"
                  :item-props="itemProps"
                  auto-select-first
                  @update:model-value="onChange"
                  :variant="(outlined) ? 'outlined' : undefined"
                  :density="dense ? 'compact' : undefined"
                  :model-value="value"
                  :error-messages="errorMessage"
                  :hint="hint" :persistent-hint="!!hint"
                  :creatable="creatable"
                  @create="$emit('create', $event)">
      <!-- A régua na opção e no escolhido: o desenho de todo campo de relacionamento -->
      <template #item="{item, props}">
        <ontos-rel-option v-bind="props" :item="item" :density="dense ? 'compact' : undefined"/>
      </template>
      <template #selection="{item}">
        <ontos-rel-selection :item="item" :removable="canRemove" @remove="remove($event)"/>
      </template>
  </ontos-creatable-autocomplete>

</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import IdeaProperty from "@/types/IdeaProperty";
import {optionIdOf} from "@/utils/propertyDisplay"
import RelOption from "@/components/live/instance/RelOption.vue";
import RelSelection from "@/components/live/instance/RelSelection.vue";
import CreatableAutocomplete from "@/components/shared/CreatableAutocomplete.vue";
import {isClearable} from "@/utils/fieldRules";

type Instance = {
  _identifier: string
  _instance: number
}




@Component({
  emits: ['input', 'create'],
  components: {
    'ontos-creatable-autocomplete': CreatableAutocomplete,
    'ontos-rel-option': RelOption,
    'ontos-rel-selection': RelSelection
  }
})
class InstanceRelInput extends Vue {
  //não é required: reverso de valor único vazio chega como null
  @Prop({type: [Number, Array], default: null}) readonly value!: number | number[]
  @Prop({type: Array, required: true}) readonly items!: Instance[]
  @Prop({type: Object, required: true}) readonly property!: IdeaProperty
  @Prop({type: Boolean, default: false}) readonly readonly!: boolean
  @Prop({type: Boolean, default: false}) readonly hideLabel!: boolean
  @Prop({type: Boolean, default: false}) readonly outlined!: boolean
  @Prop({type: Boolean, default: false}) readonly dense!: boolean
  @Prop({type: Boolean, default: false}) readonly forceMultiple!: boolean
  //ids que não podem ser marcados nem desmarcados no dropdown
  @Prop({type: Array, default: () => []}) readonly disabledValues!: number[]
  @Prop({type: Boolean, default: true}) readonly allowRemove!: boolean
  /** Obrigatório não se limpa. O filtro da listagem nunca é, e por isso o padrão é falso. */
  @Prop({type: Boolean, default: false}) readonly required!: boolean
  @Prop({type: String, default: ""}) readonly errorMessage!: string
  /** Orientação embaixo do campo, no lugar das mensagens do próprio Vuetify — o erro passa por cima. */
  @Prop({type: String, default: ""}) readonly hint!: string
  /** Desligado por padrão: o filtro da listagem só escolhe. Quem cria é o reverso. */
  @Prop({type: Boolean, default: false}) readonly creatable!: boolean

  get isMultiple() {
    return this.forceMultiple || this.property.multiple
  }

  /**
   * Tira um item da escolha — da lista, ou o único.
   *
   * Existe porque o chip saiu: era dele que vinha o X, com a remoção que o Vuetify faz
   * sozinho. O que sai daqui é o mesmo valor que o campo emitiria — só o desenho mudou.
   */
  remove(item: any) {
    if (!this.isMultiple) {
      this.$emit('input', null)
      return
    }
    const id = optionIdOf(item)
    const kept = (Array.isArray(this.value) ? this.value : [])
        .filter((current: any) => Number(current) !== id)
    this.$emit('input', kept)
  }

  /**
   * Remover só quando o campo deixa: o X não aparece em leitura nem onde a chave proíbe. No de um valor
   * só, o × junto do valor no lugar do X de limpar do Vuetify (relato do usuário: o modelo é o da
   * Parceria), pela regra de quem limpa — obrigatório não se limpa.
   */
  get canRemove(): boolean {
    if (!this.isMultiple) {
      return isClearable({readonly: this.readonly, required: this.required, allowRemove: this.allowRemove})
    }
    return this.allowRemove && !this.readonly
  }

  //O Vuetify 4 mescla o que vem daqui nas props do v-list-item do item (o title e o
  //value continuam vindo de item-title/item-value). Substitui o item-disabled do 2.
  itemProps(item: any) {
    return {disabled: this.disabledValues.indexOf(item && item._instance) >= 0}
  }

  onChange($event: any) {
    this.$emit('input', $event) //para atualizar o v-model
  }
}

export default toNative(InstanceRelInput)
</script>

